import { useContext } from "react";
import jwtDecode from "jwt-decode";
import { StoreContext } from "../store/StoreContext";
import { SMU_TOKEN, SMU_USER } from "../constants";
import { getUserStores } from "../api/users";
import { getStoresByIds } from "../api/stores";
import { toast } from "../helpers/smu-alerts/smu-lerts";

const useAuth = () => {
  const {
    setLoggedUser,
    setIsAdmin
  } = useContext(StoreContext);

  const validate = async ({ data = {} }) => {
 
    if( Object.keys(data).length > 0 ) {
        localStorage.setItem(SMU_TOKEN, data.token);
        localStorage.setItem(SMU_USER, JSON.stringify(data.user));
        
        try {
          const userStores = await getUserStores();
          // Assign store to SMU_USER and update localStorage
          // Assign as list of stores
          const storeRelationShipIds = userStores.data.filter(d => d.idUsuario == data.user.username).map(d => d.idTiendas);

          if (storeRelationShipIds.length > 0) {
            const storeData = await getStoresByIds(storeRelationShipIds);
            data.user.store = storeData?.data?.map(d => d.codLocal) || null;
            localStorage.setItem(SMU_USER, JSON.stringify(data.user));
            setLoggedUser(data.user);
          } else {
            data.user.store = null;
            localStorage.setItem(SMU_USER, JSON.stringify(data.user));
            setLoggedUser(data.user);
          }
        } catch (error) {
          toast.error('Error al obtener la tienda del usuario.');
          data.user.store = null;
          localStorage.setItem(SMU_USER, JSON.stringify(data.user));
          setLoggedUser(data.user);
        }
    }
    
    const user = localStorage.getItem(SMU_USER) ?? undefined;
    const token = localStorage.getItem(SMU_TOKEN)?? undefined;
    
    if(token){
    
        const _tokenData = jwtDecode(token);
        setLoggedUser(JSON.parse(user));
        setIsAdmin((_tokenData?.admin == true || _tokenData?.admin == "true"));
    }
    
  }

  return { validate };
};

export default useAuth;




